import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

function Footer() {
  const [showSuccess, setShowSuccess] = useState(false);
  const [email, setEmail] = useState("");

  const handleFormSubmit = (e) => {
    e.preventDefault();
    fetch(
      "https://pradeepponiahathras.000webhostapp.com/backend/suscribe.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ email }),
      }
    )
      .then((response) => response.text())
      .then(() => {
        setEmail("");
        setShowSuccess(true);
        setTimeout(() => setShowSuccess(false), 2000);
      })
      .catch((error) => console.error("Error:", error));
  };

  const springConfig = { type: "spring", stiffness: 300, damping: 15 };

  return (
    <footer
      className="position-relative text-light overflow-hidden pt-5"
      id="footer"
      style={{
        backgroundColor: "#0d131a", // Deep Midnight Black
        fontFamily: "'Inter', sans-serif",
      }}
    >
      {/* Background Dynamic Blur Blobs for Premium Glassmorphism Look */}
      <div
        className="position-absolute rounded-circle opacity-10"
        style={{
          width: "400px",
          height: "400px",
          background: "var(--brand-mineral-aqua)",
          top: "-150px",
          left: "-100px",
          filter: "blur(120px)",
          pointerEvents: "none",
        }}
      />
      <div
        className="position-absolute rounded-circle opacity-10"
        style={{
          width: "300px",
          height: "300px",
          background: "var(--brand-copper)",
          bottom: "-50px",
          right: "-50px",
          filter: "blur(90px)",
          pointerEvents: "none",
        }}
      />

      {/* ================= TOP PREMIUM IMPACT BANNER ================= */}
      <div className="container-fluid px-4 px-md-5 mb-5">
        <motion.div
          className="p-4 border d-flex flex-column flex-lg-row align-items-center justify-content-between gap-4 position-relative overflow-hidden"
          style={{
            background: "rgba(255, 255, 255, 0.03)",
            borderColor: "rgba(255, 255, 255, 0.07)",
            backdropFilter: "blur(20px)",
            borderRadius: "24px",
          }}
          whileHover={{ scale: 1.01, borderColor: "var(--brand-mineral-aqua)" }}
          transition={{ duration: 0.4 }}
        >
          <div
            className="position-absolute top-0 start-0 h-100"
            style={{
              width: "6px",
              backgroundColor: "var(--brand-mineral-aqua)",
            }}
          />

          <div className="text-center text-lg-start ps-lg-3">
            <span
              className="badge text-uppercase tracking-widest mb-2 px-3 py-1"
              style={{
                backgroundColor: "rgba(54, 191, 216, 0.15)",
                color: "var(--brand-mineral-aqua)",
                fontSize: "0.75rem",
              }}
            >
              Humanitarian Framework
            </span>
            <h4
              className="fw-bold mb-1 text-white"
              style={{ letterSpacing: "-0.5px" }}
            >
              Born for Charity, Built for Impact
            </h4>
            <p className="text-white-50 small mb-0">
              NGO Waters cleanly dedicates 50% of net profits explicitly toward
              fresh water pipelines and deep regional boring setups.
            </p>
          </div>

          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            transition={springConfig}
          >
            <Link
              to="/aboutus"
              className="btn px-4 py-2.5 fw-bold d-flex align-items-center gap-2 border-0 shadow-sm"
              style={{
                backgroundColor: "var(--brand-mineral-aqua)",
                color: "var(--brand-deep-blue)",
                borderRadius: "12px",
              }}
            >
              Explore Our Mission{" "}
              <i className="bi bi-arrow-right-short fs-5"></i>
            </Link>
          </motion.div>
        </motion.div>
      </div>

      {/* ================= CORE INTERACTIVE COLUMN MATRIX ================= */}
      <div className="container-fluid px-4 px-md-5 pb-5">
        <div className="row g-4 justify-content-between">
          {/* COLUMN 1: Partnership & Scale */}
          <div className="col-6 col-sm-6 col-md-3 col-lg-2">
            <h6
              className="text-uppercase tracking-widest fw-bold mb-4 position-relative pb-2"
              style={{ color: "var(--brand-sky-blue)", fontSize: "0.8rem" }}
            >
              Partnerships
              <span
                className="position-absolute bottom-0 start-0"
                style={{
                  width: "30px",
                  height: "2px",
                  backgroundColor: "var(--brand-mineral-aqua)",
                }}
              />
            </h6>
            <div className="d-flex flex-column gap-2.5">
              {[
                { name: "Become Distributor", path: "/distributor" },
                { name: "Discount Matrix", path: "/discount" },
                { name: "Company Hierarchy", path: "/hierarchy" },
                { name: "Career Ecosystem", path: "/career" },
              ].map((link, idx) => (
                <motion.div
                  key={idx}
                  whileHover={{ x: 6 }}
                  transition={{ type: "spring", stiffness: 200, damping: 12 }}
                >
                  <Link
                    to={link.path}
                    className="text-white-50 text-decoration-none small dynamic-link-node"
                  >
                    {link.name}
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>

          {/* COLUMN 2: Trust & Media */}
          <div className="col-6 col-sm-6 col-md-3 col-lg-2">
            <h6
              className="text-uppercase tracking-widest fw-bold mb-4 position-relative pb-2"
              style={{ color: "var(--brand-sky-blue)", fontSize: "0.8rem" }}
            >
              Trust Layers
              <span
                className="position-absolute bottom-0 start-0"
                style={{
                  width: "30px",
                  height: "2px",
                  backgroundColor: "var(--brand-mineral-aqua)",
                }}
              />
            </h6>
            <div className="d-flex flex-column gap-2.5">
              {[
                { name: "Quality Reports", path: "/quality" },
                { name: "Media Center", path: "/media" },
                { name: "News & Stories", path: "/news" },
                { name: "Document Center", path: "/resources" },
              ].map((link, idx) => (
                <motion.div
                  key={idx}
                  whileHover={{ x: 6 }}
                  transition={{ type: "spring", stiffness: 200, damping: 12 }}
                >
                  <Link
                    to={link.path}
                    className="text-white-50 text-decoration-none small dynamic-link-node"
                  >
                    {link.name}
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>

          {/* COLUMN 3: Support & Engagement */}
          <div className="col-6 col-sm-6 col-md-3 col-lg-2">
            <h6
              className="text-uppercase tracking-widest fw-bold mb-4 position-relative pb-2"
              style={{ color: "var(--brand-sky-blue)", fontSize: "0.8rem" }}
            >
              Engagement
              <span
                className="position-absolute bottom-0 start-0"
                style={{
                  width: "30px",
                  height: "2px",
                  backgroundColor: "var(--brand-mineral-aqua)",
                }}
              />
            </h6>
            <div className="d-flex flex-column gap-2.5">
              {[
                { name: "Help & FAQ Desk", path: "/faq" },
                { name: "Ask a Question", path: "/askquestion" },
                { name: "Submit Feedback", path: "/feedback" },
                { name: "Legal Compliance", path: "/t&c" },
              ].map((link, idx) => (
                <motion.div
                  key={idx}
                  whileHover={{ x: 6 }}
                  transition={{ type: "spring", stiffness: 200, damping: 12 }}
                >
                  <Link
                    to={link.path}
                    className="text-white-50 text-decoration-none small dynamic-link-node"
                  >
                    {link.name}
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>

          {/* COLUMN 4: Corporate Hub Address Area */}
          <div className="col-12 col-md-6 col-lg-3">
            <h6
              className="text-uppercase tracking-widest fw-bold mb-4 position-relative pb-2"
              style={{ color: "var(--brand-sky-blue)", fontSize: "0.8rem" }}
            >
              Operational Hub
              <span
                className="position-absolute bottom-0 start-0"
                style={{
                  width: "30px",
                  height: "2px",
                  backgroundColor: "var(--brand-copper)",
                }}
              />
            </h6>
            <address
              className="text-white-50 mb-3 small"
              style={{ lineHeight: "1.7" }}
            >
              <span className="text-white fw-bold d-block mb-1">
                PONIA FOOD AND BEVERAGE PVT. LTD.
              </span>
              C/O Shri Pal Singh, Village - Subakara,
              <br />
              Thana - Gonda, Aligarh, UP - 202123
              <span
                className="d-block mt-1 font-monospace"
                style={{ color: "var(--brand-copper)", fontSize: "0.78rem" }}
              >
                CIN: U11043UP2024PTC213517
              </span>
            </address>

            <div className="d-flex flex-column gap-2">
              <a
                href="mailto:poniafoodandbeveragepvtltd@gmail.com"
                className="text-white-50 text-decoration-none small d-flex align-items-center gap-2 custom-mail-phone"
              >
                <i
                  className="bi bi-envelope-open-fill text-muted"
                  style={{ fontSize: "0.8rem" }}
                ></i>
                poniafoodandbeveragepvtltd@gmail.com
              </a>
              <a
                href="tel:+917060116679"
                className="text-white-50 text-decoration-none small d-flex align-items-center gap-2 custom-mail-phone"
              >
                <i
                  className="bi bi-telephone-fill text-muted"
                  style={{ fontSize: "0.8rem" }}
                ></i>
                +91 7060116679
              </a>
            </div>
          </div>

          {/* COLUMN 5: Ecosystem Pulse / Newsletter */}
          <div className="col-12 col-md-6 col-lg-3">
            <div
              className="p-3.5 rounded-3"
              style={{
                background: "rgba(255,255,255,0.02)",
                border: "1px solid rgba(255,255,255,0.05)",
              }}
            >
              <h6
                className="text-uppercase tracking-widest fw-bold mb-1.5 text-white"
                style={{ fontSize: "0.8rem" }}
              >
                Ecosystem Pulse
              </h6>
              <p className="text-white-50 mb-3" style={{ fontSize: "0.82rem" }}>
                Subscribe to monitor verified freshwater setups.
              </p>

              <form onSubmit={handleFormSubmit}>
                <div
                  className="p-1 rounded-3 d-flex align-items-center gap-1"
                  style={{
                    background: "rgba(0,0,0,0.3)",
                    border: "1px solid rgba(255,255,255,0.08)",
                  }}
                >
                  <input
                    type="email"
                    className="form-control form-control-sm bg-transparent border-0 text-white shadow-none ps-2"
                    placeholder="name@domain.com"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                  <motion.button
                    whileHover={{
                      scale: 1.04,
                      backgroundColor: "var(--brand-mineral-aqua)",
                      color: "var(--brand-deep-blue)",
                    }}
                    whileTap={{ scale: 0.96 }}
                    className="btn btn-sm fw-bold px-3 py-2 border-0 text-white"
                    type="submit"
                    style={{
                      backgroundColor: "rgba(255,255,255,0.06)",
                      borderRadius: "8px",
                      transition: "all 0.2s",
                    }}
                  >
                    Join
                  </motion.button>
                </div>
              </form>

              {showSuccess && (
                <motion.div
                  initial={{ opacity: 0, y: 5 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="alert alert-success border-0 text-center small py-1.5 mt-2 mb-0"
                  style={{
                    background: "rgba(25, 135, 84, 0.2)",
                    color: "#198754",
                  }}
                >
                  <strong>Cleanly Subscribed!</strong>
                </motion.div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Global CSS Hover Style Overrides Injection */}
      <style>{`
        .dynamic-link-node { transition: color 0.25s ease; font-size: 0.88rem !important; display: inline-block; }
        .dynamic-link-node:hover { color: var(--brand-mineral-aqua) !important; }
        .custom-mail-phone { transition: color 0.2s ease; }
        .custom-mail-phone:hover { color: #ffffff !important; }
        .footer-legal-bar a { transition: color 0.2s; text-decoration: none; }
        .footer-legal-bar a:hover { color: var(--brand-mineral-aqua) !important; }
        .gap-2.5 { gap: 0.65rem !important; }
        .p-3.5 { padding: 1.15rem !important; }
      `}</style>

      {/* ================= LOWER SOCIALS & COMPLIANCE DATA DECK ================= */}
      <div
        className="container-fluid px-4 px-md-5 border-top"
        style={{ borderColor: "rgba(255,255,255,0.06)" }}
      >
        <div className="row py-4 align-items-center gy-3">
          {/* Copyright Left Text */}
          <div className="col-lg-5 text-center text-lg-start">
            <p className="mb-0 small text-white-50">
              © 2026 NGO Waters. Powered securely by{" "}
              <span className="text-white fw-medium">
                Ponia Food and Beverage Private Limited
              </span>
              .
            </p>
          </div>

          {/* Compliance Legal Anchors Middle Matrix */}
          <div
            className="col-lg-4 text-center footer-legal-bar d-flex justify-content-center gap-3.5"
            style={{ fontSize: "0.82rem" }}
          >
            <Link to="/privacy-policy" className="text-white-50">
              Privacy Protocol
            </Link>
            <span className="text-muted opacity-25">|</span>
            <Link to="/t&c" className="text-white-50">
              Terms Matrix
            </Link>
            <span className="text-muted opacity-25">|</span>
            <Link to="/refund_return" className="text-white-50">
              Refund & Return
            </Link>
          </div>

          {/* Social Icons Media Handles Right Grid */}
          <div className="col-lg-3 d-flex justify-content-center justify-content-lg-end gap-2.5">
            {[
              {
                url: "https://www.facebook.com/profile.php?id=61551638147009",
                icon: "bi-facebook",
              },
              {
                url: "https://www.linkedin.com/in/ngo-waters-4a65b735a/",
                icon: "bi-linkedin",
              },
              {
                url: "https://www.instagram.com/ngo_waters/?hl=en",
                icon: "bi-instagram",
              },
              {
                url: "https://youtube.com/@ngowaters?si=ALfEdaXh_CGbph6Y",
                icon: "bi-youtube",
              },
            ].map((social, idx) => (
              <motion.a
                key={idx}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center justify-content-center rounded-circle text-decoration-none text-white-50"
                style={{
                  width: "36px",
                  height: "36px",
                  background: "rgba(255,255,255,0.03)",
                  border: "1px solid rgba(255,255,255,0.06)",
                }}
                whileHover={{
                  y: -4,
                  backgroundColor: "rgba(255, 255, 255, 0.08)",
                  borderColor: "var(--brand-mineral-aqua)",
                  color: "var(--brand-mineral-aqua)",
                }}
                transition={springConfig}
              >
                <i className={`bi ${social.icon} fs-5`}></i>
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
